import { Roles } from '#interfacesv2/api/user/enum/roles.enum';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

export const SignedInRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const authService = inject(AuthService);

    const user = authService.getLoggedInUserFromStorage();

    if (user?.role === Roles.AccessManager) {
        return router.createUrlTree(['/globalConfig/users']);
    }

    return router.createUrlTree(['/dashboard/main']);
};
